import { component } from "picoapp";
import { store } from "@/vue/config/store";

export default component(async (node) => {
  const [{ default: KeenSlider }] = await Promise.all([
    import("keen-slider"),
    import("keen-slider/keen-slider.min.css"),
  ]);

  const sliderElement = node.querySelector("[data-keen-slider]");
  const addToCart = node.querySelector("[data-add-to-cart]");
  const productLink = node.querySelector("[data-product-link]");
  const slider = new KeenSlider(sliderElement, {
    loop: true,
    drag: false,
    slideChanged: (s) => {
      s.slides.forEach((slide, index) => {
        slide.style.zIndex = s.track.details.slides[index].portion;
        slide.style.opacity = s.track.details.slides[index].portion;
      });
    },
    detailsChanged: (s) => {
      const width = s.size;
      s.slides.forEach((slide, index) => {
        slide.style.zIndex = s.track.details.slides[index].portion;
        slide.style.transform = `translate3d(-${width * index}px, 0px, 0px)`;
        slide.style.minWidth = width + "px";
        slide.style.maxWidth = width + "px";
        slide.style.opacity = s.track.details.slides[index].portion;
      });
    },
    created(s) {
      s.container.classList.remove("hide-init");
    },
  });

  const options = node.querySelectorAll('input[type="radio"]');
  options.forEach((option) => {
    option.addEventListener("click", function () {
      const index = option.dataset.index;
      slider.moveToIdx(parseInt(index));
      if (productLink) {
        const url = new URL(productLink.href);
        url.searchParams.set("variant", option.dataset.vid);
        productLink.href = url.href;
      }

      if (addToCart && option.dataset.oos) {
        addToCart.classList.add("oos");
        addToCart.innerHTML = addToCart.dataset.oosText;
      } else if (addToCart && !option.dataset.oos) {
        addToCart.classList.remove("oos");
        addToCart.innerHTML = addToCart.dataset.text;
      }
    });
  });

  window.addEventListener("option-change:color", (event) => {
    const { value, checked, unchecked } = event.detail;
    if (value) {
      const optionElement = node.querySelector(`input[value="${checked}"]`);
      if (optionElement) optionElement.click();
    } else {
      const optionElement = node.querySelector(`input[value="${unchecked}"]`);
      if (optionElement) optionElement.click();
    }
  });

  if (addToCart) {
    addToCart.addEventListener("click", async () => {
      const optionsForm = node.querySelector("[data-options]");
      if (!optionsForm) return;
      const optionElement = optionsForm.querySelector(
        'input[type="radio"]:checked'
      );
      if (optionElement && optionElement.dataset.vid) {
        try {
          const cart = await store.dispatch("cart/addToCart", [
            {
              id: parseInt(optionElement.dataset.vid),
              quantity: 1,
              properties: {
                _created_at: Date.now(),
              },
            },
          ]);

          if (cart) store.dispatch("cart/toggleCart");
        } catch (error) {
          console.error(error);
        }
      }
    });
  }
});
